<template>
  <div class="imge-course-wrapper">
    <Banner :bannerImg="Img1"></Banner>

    <!-- 面包屑 -->
    <div class="Crumbs container-fixed">
      <div>
        当前位置：<router-link to="/">首页</router-link> &gt;
        <router-link to="/camodule">西部CA办理</router-link> &gt;
        <span>图文教程详情</span>
      </div>
    </div>

    <main class="main-content container-fixed">
      <article class="detail-card card-modern" v-loading="loading">
        <header class="detail-header">
          <h1 class="title">{{ imgdetailList.tittle }}</h1>
          <div class="meta-info">
            <span
              ><i class="el-icon-time"></i> 更新时间：{{
                imgdetailList.updateTime
              }}</span
            >
          </div>
        </header>

        <div
          class="detail-body rich-text-content"
          v-html="imgdetailList.message"
        ></div>
      </article>
    </main>
  </div>
</template>

<script>
import article from "@/api/article";
import Banner from "@/components/banner.vue";

export default {
  name: "ImgeCourse",
  components: {
    Banner,
  },
  data() {
    return {
      Img1: require("@/assets/images/banner1.png"),
      loading: false,
      imgdetailList: {},
    };
  },
  created() {
    if (this.$route.query) {
      let id = this.$route.query.id;
      this.getList(id);
    }
  },
  methods: {
    getList(id) {
      this.loading = true;
      article
        .getImgDetail({ id: id })
        .then((res) => {
          this.imgdetailList = res.data.data;
          this.loading = false;
        })
        .catch((err) => {
          console.error(err);
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/styles/variables.less";

.imge-course-wrapper {
  background-color: @bg-base;
}

.Crumbs {
  padding: 20px 0;
  font-size: 14px;
  color: @text-secondary;
  span {
    color: @text-main;
    font-weight: 500;
  }
  a:hover {
    color: @primary-color;
  }
}

.main-content {
  padding-bottom: 80px;
}

.detail-card {
  background: #ffffff;
  padding: 60px 80px;
  border-radius: @border-radius;
}

.detail-header {
  text-align: center;
  margin-bottom: 40px;
  padding-bottom: 32px;
  border-bottom: 1px solid @border-color;

  .title {
    font-size: 28px;
    font-weight: 700;
    color: @text-main;
    margin-bottom: 24px;
    line-height: 1.4;
  }

  .meta-info {
    font-size: 14px;
    color: @text-muted;
    display: flex;
    justify-content: center;
    gap: 32px;
    i {
      margin-right: 6px;
    }
  }
}

.detail-body {
  font-size: 16px;
  line-height: 1.8;
  color: @text-secondary;
  min-height: 400px;

  /deep/ img {
    max-width: 100% !important;
    height: auto !important;
    border-radius: 4px;
    margin: 24px 0;
  }

  /deep/ p {
    margin-bottom: 16px;
  }

  /deep/ table {
    width: 100% !important;
    border-collapse: collapse;
    margin: 24px 0;
    td,
    th {
      border: 1px solid @border-color;
      padding: 12px;
    }
  }
}

.detail-footer {
  margin-top: 60px;
  padding-top: 32px;
  border-top: 1px solid @border-color;
  display: flex;
  justify-content: center;
}

@media (max-width: 768px) {
  .detail-card {
    padding: 32px 20px;
  }
  .detail-header .title {
    font-size: 22px;
  }
  .meta-info {
    flex-direction: column;
    gap: 12px;
  }
}
</style>
